<div class="modal-content border-0 shadow-lg">
    <div class="modal-header border-bottom py-4 px-5" style="background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);">
        <div>
            <h4 class="modal-title mb-1 fw-semibold" style="color: #2E3643; letter-spacing: -0.5px;">
                Evidencias de Inspección
            </h4>
            <small style="color: #7B8298;">Registro fotográfico y detalles técnicos</small>
        </div>
        <button type="button" class="btn-close" style="font-size: 0.8rem;" (click)="close()"></button>
    </div>

    <div class="modal-body px-5 py-4" style="max-height: 72vh; overflow-y: auto; background-color: #fafbfc;">
        <!-- Loading -->
        <div *ngIf="isLoading" class="text-center py-5">
            <div class="spinner-border" style="color: #8D9FB3; width: 2.5rem; height: 2.5rem; border-width: 0.2rem;" role="status">
                <span class="visually-hidden">Cargando...</span>
            </div>
            <p class="mt-4 mb-0" style="color: #7B8298; font-size: 0.95rem;">Cargando evidencias...</p>
        </div>

        <!-- Contenido -->
        <div *ngIf="!isLoading && inspectionData">

            <!-- Info de Inspección - Profesional -->
            <div class="card border-0 mb-4" style="background-color: white; box-shadow: 0 2px 12px rgba(46, 54, 67, 0.06);">
                <div class="card-body p-4">
                    <!-- Header de la card -->
                    <div class="d-flex align-items-center mb-4 pb-3 border-bottom">
                        <div class="rounded-circle d-flex align-items-center justify-content-center me-3"
                             style="width: 40px; height: 40px; background-color: #8D9FB3; opacity: 0.1;">
                            <span style="font-size: 1.2rem;">📋</span>
                        </div>
                        <div>
                            <h6 class="mb-0 fw-semibold" style="color: #2E3643; font-size: 0.95rem;">Información General</h6>
                            <small style="color: #7B8298; font-size: 0.8rem;">Datos registrados en la inspección</small>
                        </div>
                    </div>

                    <div class="row g-4">
                        <!-- Columna 1 -->
                        <div class="col-lg-4 col-md-6">
                            <div class="info-item">
                                <small class="d-block mb-2" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">Placa del Vehículo</small>
                                <div class="fw-bold" style="color: #2E3643; font-size: 1.25rem; letter-spacing: 0.5px;">{{ vehiclePlates }}</div>
                            </div>
                        </div>

                        <!-- Columna 2 -->
                        <div class="col-lg-4 col-md-6">
                            <div class="info-item">
                                <small class="d-block mb-2" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">Orden de Servicio</small>
                                <div class="d-flex align-items-baseline">
                                    <span style="color: #8D9FB3; font-size: 1rem; margin-right: 4px;">#</span>
                                    <span class="fw-bold" style="color: #2E3643; font-size: 1.25rem;">{{ serviceId }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Columna 3 -->
                        <div class="col-lg-4 col-md-6">
                            <div class="info-item">
                                <small class="d-block mb-2" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">Tipo de Inspección</small>
                                <span class="badge px-3 py-2" style="background-color: #8D9FB3; color: white; font-weight: 500; font-size: 0.85rem; letter-spacing: 0.3px;">
                  {{ inspectionData.inspectionType === 'exit' ? 'Salida' : 'Entrada' }}
                </span>
                            </div>
                        </div>

                        <!-- Columna 4 -->
                        <div class="col-lg-4 col-md-6">
                            <div class="info-item">
                                <small class="d-block mb-2" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">Kilometraje</small>
                                <div class="d-flex align-items-baseline">
                                    <span class="fw-bold" style="color: #2E3643; font-size: 1.25rem;">{{ inspectionData.km }}</span>
                                    <small class="ms-2" style="color: #7B8298; font-size: 0.85rem;">km</small>
                                </div>
                            </div>
                        </div>

                        <!-- Columna 5 -->
                        <div class="col-lg-4 col-md-6">
                            <div class="info-item">
                                <small class="d-block mb-2" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">Nivel de Combustible</small>
                                <div class="d-flex align-items-center">
                                    <span class="fw-bold me-3" style="color: #2E3643; font-size: 1.25rem;">{{ inspectionData.fuelLevel }}%</span>
                                    <div class="progress flex-grow-1" style="height: 6px; background-color: #e9ecef;">
                                        <div class="progress-bar"
                                             style="background: linear-gradient(90deg, #8D9FB3 0%, #7B8298 100%);"
                                             [style.width.%]="inspectionData.fuelLevel">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Columna 6 -->
                        <div class="col-lg-4 col-md-6">
                            <div class="info-item">
                                <small class="d-block mb-2" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">Fecha de Inspección</small>
                                <div style="color: #2E3643;">
                                    <div class="fw-semibold" style="font-size: 1rem;">{{ inspectionData.inspectionDate | date:'dd/MM/yyyy' }}</div>
                                    <small style="color: #7B8298; font-size: 0.85rem;">{{ inspectionData.inspectionDate | date:'HH:mm:ss' }}</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Incidentes - Profesional -->
                    <div *ngIf="inspectionData.hasIncidents && getIncidentTypesArray().length > 0"
                         class="mt-4 pt-4 border-top">
                        <div class="d-flex align-items-center mb-3">
                            <div class="rounded-circle me-2" style="width: 8px; height: 8px; background-color: #2E3643;"></div>
                            <small style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">
                                Incidentes Reportados
                            </small>
                        </div>
                        <div class="d-flex flex-wrap gap-2">
              <span *ngFor="let incident of getIncidentTypesArray()"
                    class="badge px-3 py-2"
                    style="background-color: #2E3643; color: white; font-weight: 400; font-size: 0.8rem; letter-spacing: 0.3px;">
                {{ incident }}
              </span>
                        </div>
                    </div>

                    <!-- Sin Incidentes -->
                    <div *ngIf="!inspectionData.hasIncidents || getIncidentTypesArray().length === 0"
                         class="mt-4 pt-4 border-top">
                        <div class="d-flex align-items-center">
                            <div class="rounded-circle me-3 d-flex align-items-center justify-content-center"
                                 style="width: 32px; height: 32px; background-color: #8D9FB3; opacity: 0.15;">
                                <span style="font-size: 1rem;">✓</span>
                            </div>
                            <span style="color: #8D9FB3; font-size: 0.9rem; font-weight: 500;">Sin incidentes reportados</span>
                        </div>
                    </div>

                    <!-- Observaciones -->
                    <div *ngIf="inspectionData.observations && inspectionData.observations.trim() !== ''"
                         class="mt-4 pt-4 border-top">
                        <small class="d-block mb-3" style="color: #7B8298; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; font-weight: 600;">
                            Observaciones Generales
                        </small>
                        <p class="mb-0" style="color: #2E3643; line-height: 1.7; font-size: 0.95rem;">
                            {{ inspectionData.observations }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Separador con título -->
            <div class="d-flex align-items-center mb-4 mt-5">
                <div style="flex: 1; height: 1px; background: linear-gradient(90deg, transparent 0%, #dee2e6 50%, transparent 100%);"></div>
                <h6 class="mx-4 mb-0 fw-semibold" style="color: #7B8298; font-size: 0.75rem; text-transform: uppercase; letter-spacing: 1.5px;">
                    Evidencias Fotográficas
                </h6>
                <div style="flex: 1; height: 1px; background: linear-gradient(90deg, transparent 0%, #dee2e6 50%, transparent 100%);"></div>
            </div>

            <!-- Foto del Tablero -->
            <div *ngIf="evidences.dashboard.length > 0" class="mb-5">
                <div class="d-flex align-items-center mb-3">
                    <div class="me-2" style="width: 3px; height: 20px; background-color: #8D9FB3;"></div>
                    <span class="fw-semibold" style="color: #2E3643; font-size: 0.95rem;">Fotografía del Tablero</span>
                </div>
                <div class="row g-3">
                    <div *ngFor="let photo of evidences.dashboard" class="col-md-4">
                        <div class="card border-0 h-100 photo-card-pro"
                             style="overflow: hidden; cursor: pointer; box-shadow: 0 2px 8px rgba(46, 54, 67, 0.08);"
                             (click)="openImage(photo.url)">
                            <div class="photo-wrapper">
                                <img [src]="photo.url"
                                     class="card-img-top photo-img"
                                     style="height: 200px; object-fit: cover; transition: transform 0.3s ease;"
                                     alt="Foto tablero">
                            </div>
                            <div class="card-body p-3" style="background-color: #fafbfc;">
                                <small style="color: #7B8298; font-size: 0.75rem; letter-spacing: 0.3px;">
                                    {{ photo.createdAt | date:'dd/MM/yyyy HH:mm' }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Fotos de Rutina -->
            <div *ngIf="evidences.routine.length > 0" class="mb-5">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                        <div class="me-2" style="width: 3px; height: 20px; background-color: #8D9FB3;"></div>
                        <span class="fw-semibold" style="color: #2E3643; font-size: 0.95rem;">Registro Fotográfico</span>
                    </div>
                    <span class="badge" style="background-color: #8D9FB3; color: white; font-size: 0.7rem; padding: 0.35rem 0.75rem;">
            {{ evidences.routine.length }} fotos
          </span>
                </div>
                <div class="row g-3">
                    <div *ngFor="let photo of evidences.routine" class="col-xl-3 col-lg-4 col-md-6">
                        <div class="card border-0 h-100 photo-card-pro"
                             style="overflow: hidden; cursor: pointer; box-shadow: 0 2px 8px rgba(46, 54, 67, 0.08);"
                             (click)="openImage(photo.url)">
                            <div class="photo-wrapper">
                                <img [src]="photo.url"
                                     class="card-img-top photo-img"
                                     style="height: 160px; object-fit: cover; transition: transform 0.3s ease;"
                                     alt="Foto rutina">
                            </div>
                            <div class="card-body p-2" style="background-color: #fafbfc;">
                                <small class="text-truncate d-block" style="color: #7B8298; font-size: 0.72rem;">
                                    {{ photo.section || 'General' }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Fotos de Daños -->
            <div *ngIf="evidences.damage.length > 0" class="mb-5">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                        <div class="me-2" style="width: 3px; height: 20px; background-color: #2E3643;"></div>
                        <span class="fw-semibold" style="color: #2E3643; font-size: 0.95rem;">Registro de Daños</span>
                    </div>
                    <span class="badge" style="background-color: #2E3643; color: white; font-size: 0.7rem; padding: 0.35rem 0.75rem;">
            {{ evidences.damage.length }} fotos
          </span>
                </div>
                <div class="row g-3">
                    <div *ngFor="let photo of evidences.damage" class="col-md-4">
                        <div class="card h-100 photo-card-pro"
                             style="overflow: hidden; cursor: pointer; border: 1px solid #e9ecef; box-shadow: 0 2px 8px rgba(46, 54, 67, 0.08);"
                             (click)="openImage(photo.url)">
                            <div class="position-relative photo-wrapper">
                <span class="position-absolute top-0 end-0 m-2">
                  <span class="badge" style="background-color: #2E3643; color: white; font-size: 0.7rem; box-shadow: 0 2px 4px rgba(0,0,0,0.15);">
                    Daño Reportado
                  </span>
                </span>
                                <img [src]="photo.url"
                                     class="card-img-top photo-img"
                                     style="height: 200px; object-fit: cover; transition: transform 0.3s ease;"
                                     alt="Foto daño">
                            </div>
                            <div class="card-body p-3" style="background-color: #fafbfc;">
                                <small class="d-block mb-1" style="color: #2E3643; font-weight: 500; font-size: 0.8rem;">
                                    {{ photo.section || 'Exterior' }}
                                </small>
                                <small style="color: #7B8298; font-size: 0.72rem;">
                                    {{ photo.createdAt | date:'dd/MM/yyyy HH:mm' }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Otras Evidencias -->
            <div *ngIf="evidences.other.length > 0" class="mb-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                        <div class="me-2" style="width: 3px; height: 20px; background-color: #7B8298;"></div>
                        <span class="fw-semibold" style="color: #2E3643; font-size: 0.95rem;">Documentación Adicional</span>
                    </div>
                    <span class="badge" style="background-color: #7B8298; color: white; font-size: 0.7rem; padding: 0.35rem 0.75rem;">
            {{ evidences.other.length }}
          </span>
                </div>
                <div class="row g-3">
                    <div *ngFor="let photo of evidences.other" class="col-xl-3 col-lg-4 col-md-6">
                        <div class="card border-0 h-100 photo-card-pro"
                             style="overflow: hidden; cursor: pointer; box-shadow: 0 2px 8px rgba(46, 54, 67, 0.08);"
                             (click)="openImage(photo.url)">
                            <div class="photo-wrapper">
                                <img [src]="photo.url"
                                     class="card-img-top photo-img"
                                     style="height: 160px; object-fit: cover; transition: transform 0.3s ease;"
                                     alt="Otra evidencia">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sin evidencias -->
            <div *ngIf="evidences.dashboard.length === 0 &&
                  evidences.routine.length === 0 &&
                  evidences.damage.length === 0 &&
                  evidences.other.length === 0"
                 class="text-center py-5 my-5">
                <div class="mb-3" style="font-size: 3.5rem; opacity: 0.15;">📷</div>
                <p class="mb-0" style="color: #7B8298; font-size: 0.95rem;">No hay evidencias fotográficas registradas</p>
            </div>
        </div>
    </div>

    <div class="modal-footer border-top py-4 px-5" style="background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);">
        <button type="button" class="btn px-4 py-2"
                style="background-color: white; border: 1.5px solid #dee2e6; color: #2E3643; font-weight: 500; letter-spacing: 0.3px; transition: all 0.2s ease;"
                onmouseover="this.style.borderColor='#8D9FB3'; this.style.color='#8D9FB3'"
                onmouseout="this.style.borderColor='#dee2e6'; this.style.color='#2E3643'"
                (click)="close()">
            Cerrar
        </button>
    </div>
</div>

<!-- Modal para imagen ampliada -->
<div *ngIf="selectedImage"
     class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
     style="background: rgba(46, 54, 67, 0.96); z-index: 9999; cursor: pointer; backdrop-filter: blur(8px);"
     (click)="closeImage()">
    <div class="position-relative" style="max-width: 95%; max-height: 95%; animation: zoomIn 0.2s ease;">
        <img [src]="selectedImage"
             class="img-fluid"
             style="max-height: 90vh; max-width: 90vw; border-radius: 4px; box-shadow: 0 20px 60px rgba(0,0,0,0.4);"
             alt="Imagen ampliada">
        <button type="button"
                class="btn position-absolute d-flex align-items-center justify-content-center"
                style="top: -15px; right: -15px; background-color: white; color: #2E3643; width: 44px; height: 44px; border-radius: 50%; border: none; box-shadow: 0 4px 12px rgba(0,0,0,0.2); font-size: 1.2rem; font-weight: 300; transition: all 0.2s ease;"
                onmouseover="this.style.backgroundColor='#2E3643'; this.style.color='white'; this.style.transform='scale(1.1)'"
                onmouseout="this.style.backgroundColor='white'; this.style.color='#2E3643'; this.style.transform='scale(1)'"
                (click)="closeImage(); $event.stopPropagation()">
            ✕
        </button>
    </div>
</div>
